import React from 'react'
import useStyles from './tag-list.style'
const TagList = ({ data, linkify, linkPrefix }) => {
  const classes = useStyles()
  return (
    <div>
      {data.map((item = '', index) => {
        return (
          <span
            key={`${item}-${index}`}
            className={classes.tag}
            style={{ marginRight: index < data.length - 1 ? 7 : 0 }}
          >
            {linkify
              ? (
                <a
                  href={linkPrefix ? `${linkPrefix}${item}` : item}
                  rel='noopener noreferrer'
                  target='_blank'
                >{item}
                </a>)
              : item}
          </span>)
      })}
    </div>
  )
}

export default TagList
